import { Component, Prop } from 'vue-property-decorator';
import { LocationDTO } from '../../../model/LocationDTO';
import { Block } from '../../../helpers/components';
import { BaseBlock } from '../../base-block';
import { GalleryCrossFadingImages } from "@/components/gallery-cross-fading-images/gallery-cross-fading-images";
import { apartmentLocationHeadingGalleryData } from './apartment-location-heading.data';
import { ImageResourceDTO } from '../../../model/ImageResourceDTO';

@Block(apartmentLocationHeadingGalleryData)
@Component({
	components: {
		GalleryCrossFadingImages
	}
})
export class ApartmentLocationHeadingBlock extends BaseBlock {
	@Prop() location: LocationDTO;
	@Prop() gallery: ImageResourceDTO[][];

		get city() {
		var result = this.location.city;
		if (this.location.cityPart) {
			result += " - " + this.location.cityPart;
		}

		return result;
	}

	get multimediaContainerFull() {
		return this.getText('multimedia-container-full').toLowerCase() === 'true' ? true : false;
	}

	get showBreadcrumbs() {
		return !(this.$route.query.predbezne && this.$route.query.csh);
	}
}

export default ApartmentLocationHeadingBlock;
